import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { Overlay } from '@angular/cdk/overlay';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { MapService } from '../../../services/map/map.service';
import { RoutePlanningService } from '../../../services/route-planning/route-planning.service';
import { FavoritesService } from '../../../services/favorites/favorites.service';
import { BaseMap } from './base-map.component';
import { MapComponent } from './map.component';

/**
 * Plain HERE map with no address picker or search.
 * Used when a results overlay has no map of its own (e.g. lines-between-cities)
 * so the main area shows a simple map instead of the address autocomplete map.
 */
@Component({
    selector: 'app-default-map',
    templateUrl: './default-map.component.html',
    styleUrls: ['./default-map.component.scss'],
    providers: [MapService],
    standalone: false
})
export class DefaultMapComponent extends BaseMap<void> implements AfterViewInit, OnDestroy {
  @ViewChild(MapComponent) override mapComponent?: MapComponent;

  constructor(
    favoritesService: FavoritesService,
    resizeService: ResizeService,
    overlay: Overlay,
    protected override readonly mapService: MapService,
    protected override readonly routePlanningService: RoutePlanningService
  ) {
    super(favoritesService, resizeService, overlay, mapService, routePlanningService);
  }

  override ngAfterViewInit(): void {
    if (!this.mapService.map && this.mapComponent?.mapDiv) {
      this.mapService.initializeMap(this.mapComponent.mapDiv, {
        controls: {
          zoom: true,
          myLocation: true,
          scalebar: true,
        },
      });
      this._mapInitialized = true;
    }
  }

  override ngOnDestroy(): void {
    this.mapService.reset();
  }
}
